import { atom } from "jotai";

export interface ICarrierRoutingConfig {
    id?: number;
    shipment_type: string;
    primary_carrier_code: string;
    primary_service_code: string;
    primary_package_code: string;
    primary_dimensions: string;
    fallback_carrier_code: string | null;
    fallback_service_code: string | null;
    fallback_package_code: string | null;
    fallback_dimensions: string | null;
    is_active: boolean;
    created_at?: string;
    updated_at?: string;
}

export interface ICarrierRoutingConfigUpdate {
    primary_carrier_code?: string;
    primary_service_code?: string;
    primary_package_code?: string;
    primary_dimensions?: string;
    fallback_carrier_code?: string | null;
    fallback_service_code?: string | null;
    fallback_package_code?: string | null;
    fallback_dimensions?: string | null;
    is_active?: boolean;
}

export const carrierRoutingConfigsAtom = atom<ICarrierRoutingConfig[]>([]);
export const carrierRoutingConfigsLoadingAtom = atom<boolean>(false);
